<template>
  <div class="flex flex-col items-stretch grow shrink-0 justify-start">
    <div class="mb-5">
      <kt-menu class="flex flex-col gap-2">
        <!-- MAIN MENU LOOP -->
        <template v-for="item in filteredMenu" :key="item.label">
          <!-- SIMPLE LINK -->
          <kt-menu-link
            v-if="item.type === 'link'"
            :label="item.label"
            :to="item.to"
            :icon="item.icon"
            text-color="text-gray-300"
            :active="isActive(item.to)"
          />

          <!-- ACCORDION GROUP -->
          <kt-menu-item v-else-if="item.type === 'accordion'" type="accordion" trigger="click">
            <kt-menu-link :label="item.label" :icon="item.icon" show-arrow text-color="text-gray-300" />

            <kt-sub-menu type="accordion">
              <kt-menu-link
                v-for="sub in item.children"
                :key="sub.label"
                :label="sub.label"
                :to="sub.to"
                :icon="sub.icon"
                text-color="text-gray-300"
                :active="isActive(sub.to)"
              />
            </kt-sub-menu>
          </kt-menu-item>
        </template>
      </kt-menu>
    </div>
  </div>
</template>
<script setup>
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const route = useRoute();
const authStore = useAuthStore();

const role = authStore.user?.user_role?.toLowerCase() || "";

// MENU CONFIG
const menu = [
  {
    label: "Dashboard",
    icon: "ki-duotone ki-home-3",
    type: "accordion",
    role: "all",
    children: [
      {
        label: "Renewal Persistency",
        to: "/renewal-persistency",
        icon: "ki-duotone ki-trello",
      },
      {
        label: "New Business",
        to: "/new-business",
        icon: "ki-duotone ki-chart-line-star",
      },
      {
        label: "Commission Earned",
        to: "/commission-earned",
        icon: "ki-duotone ki-bill",
      },
    ],
  },
  {
    label: "User Management",
    to: "/user-management",
    icon: "ki-duotone ki-people",
    type: "link",
    role: "admin",
  },
  {
    label: "Agency Management",
    to: "/agency-management",
    icon: "ki-duotone ki-users",
    type: "link",
    role: "admin",
  },
  {
    label: "Package Types",
    to: "/package-types",
    icon: "ki-duotone ki-cheque",
    type: "link",
    role: "admin",
  },

  // CLIENT MANAGEMENT GROUP
  {
    label: "Client Management",
    icon: "ki-duotone ki-user-tick",
    type: "accordion",
    role: "all",
    children: [
      {
        label: "Clients",
        to: "/client-management",
        icon: "ki-duotone ki-people",
      },
      {
        label: "Policy Payments",
        to: "/client-payments",
        icon: "ki-duotone ki-wallet",
      },
      {
        label: "Requirements",
        to: "/client-requirements",
        icon: "ki-duotone ki-archive-tick",
      },
    ],
  },

  // COMMISSION GROUP
  {
    label: "Commission & Incentive Management",
    icon: "ki-duotone ki-dollar",
    type: "accordion",
    role: "all",
    children: [
      {
        label: "Payment Tracking",
        to: "/commission-incentives/payment-tracking",
        icon: "ki-duotone ki-financial-schedule",
        role: "all",
      },
      {
        label: "Commission Statements",
        to: "/commission-incentives/commission-statements",
        icon: "ki-duotone ki-cheque",
        role: "admin",
      },
    ],
  },
  {
    label: "Reports",
    to: "/reports",
    icon: "ki-duotone ki-tab-tablet",
    type: "link",
    role: "admin",
  },
];

// FILTER BY ROLE
// const filteredMenu = menu.filter((item) => {
//   return item.role === "all" || item.role === role || (role === "administrator" && item.role === "admin");
// });
// FILTER BY ROLE (INCLUDING CHILDREN)
const filteredMenu = menu
  .map((item) => {
    // If item has children → filter the children too
    if (item.children) {
      const filteredChildren = item.children.filter((child) => {
        return (
          !child.role || // if no role defined, show
          child.role === "all" ||
          child.role === role ||
          (role === "administrator" && child.role === "admin")
        );
      });

      // Return updated item with filtered children
      return {
        ...item,
        children: filteredChildren,
      };
    }

    // For simple links
    return item;
  })
  .filter((item) => {
    // Parent visibility rule
    const parentAllowed =
      item.role === "all" || item.role === role || (role === "administrator" && item.role === "admin");

    // If item is accordion → hide it if ALL children were filtered out
    if (item.type === "accordion") {
      return parentAllowed && item.children.length > 0;
    }

    return parentAllowed;
  });

// ACTIVE CHECK (supports nested paths)
function isActive(path) {
  return route.path.startsWith(path);
}
</script>
